export enum TerminalType {
    ISIPT = "IPT",
    ISANDROID = "ANDROID",
    ISOPT = "OPT",
    ISUNATTENDED = "UNATTENDED",
    ISECOMMERCE = "ECOMMERCE",
    ISEVCHARGER = "EVCHARGER",
}
